type OrganizationNameFallbackInput = {
  currentName?: string | null;
  companyName?: string | null;
};

function cleanName(value?: string | null): string {
  return value?.trim() ?? "";
}

export function getKnownOrganizationName({
  currentName,
  companyName,
}: OrganizationNameFallbackInput): string {
  return cleanName(currentName) || cleanName(companyName);
}

export function getScrapedOrganizationName(companyName?: string | null): string {
  return cleanName(companyName);
}

export function getOrganizationNameFallback(input: OrganizationNameFallbackInput): string {
  return getKnownOrganizationName(input) || "My Organization";
}
